import { Grid, Stack, styled, Typography } from "@mui/material";
import type React from "react";
import type { ReactNode } from "react";

const Footer = styled("div")(({ theme }) => ({
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  marginTop: theme.spacing(5),
}));

const Actions = styled("div")(() => ({
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
}));

interface Props {
  title: string;
  content: ReactNode;
  actions?: ReactNode;
  footer?: ReactNode;
  children?: undefined;
}

const containerStyles = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
};

const mainStyles = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  textAlign: "center",
  justifyContent: "center",
  backgroundColor: "white",
};

/**
 * A standard component to display empty sections for pages.
 */
export const EmptySection: React.FC<Props> = ({
  title,
  content,
  actions,
  footer,
}) => {
  return (
    <Grid spacing={5} sx={containerStyles}>
      <Grid sx={mainStyles}>
        <Stack spacing={5}>
          <Stack spacing={3}>
            <Typography variant="h6">{title}</Typography>
            <Typography variant="body1">{content}</Typography>
          </Stack>
          {actions == null ? null : <Actions>{actions}</Actions>}
        </Stack>
      </Grid>
      {footer == null ? null : (
        <Footer>
          <Typography variant="caption">{footer}</Typography>
        </Footer>
      )}
    </Grid>
  );
};
